import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AcademyLockup from "../components/brand/AcademyLockup";

// /print/logo/stacked | stacked-dark | horizontal | horizontal-dark — captured by scripts/render_logo.py
export default function PrintLogo() {
  const { variant } = useParams();
  const [ready, setReady] = useState(false);
  const dark = variant.endsWith("-dark");
  const kind = variant.startsWith("horizontal") ? "horizontal" : "stacked";
  useEffect(() => {
    if (!dark) { document.documentElement.style.background = "transparent"; document.body.style.background = "transparent"; }
    document.fonts.ready.then(() => setTimeout(() => setReady(true), 900));
  }, [dark]);
  const size = kind === "horizontal" ? 1400 : 900;
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: dark ? "#050505" : "transparent" }}>
      {ready && <span data-testid="logo-ready" className="hidden" />}
      <div data-testid="logo-frame" className="relative" style={{ padding: kind === "horizontal" ? "60px 80px" : "70px 90px", background: dark ? "radial-gradient(60% 60% at 50% 45%, rgba(212,175,55,0.10), transparent 70%), #050505" : "transparent" }}>
        <AcademyLockup variant={kind} size={size} />
      </div>
    </div>
  );
}
